import { render, staticRenderFns } from "./SurveyEditor.vue?vue&type=template&id=2266a48c"
import script from "./SurveyEditor.vue?vue&type=script&lang=js"
export * from "./SurveyEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports